<template>
  <div class="steps">
    <div @click="clickStep($index)" v-for="(step,$index) in steps" class="step" :class="{'is_finish':$index<index,'is_active':($index+1)===index}">
      <div class="steps-main">
        {{step.title}}
      </div>
      <div class="step-head">
        <div v-if="($index+1)!==steps.length" :class="{'is_finish':$index<index-1}" class="step-line"></div>
        <div class="step-icon">
          {{$index+1}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "steps",
    props: {
      steps: {
        default(){
          return [
            {
              title: "标题1",
            },
            {
              title: "标题2"
            },
            {
              title: "标题3"
            },
          ]
        }
      },
      index:{
        default:1
      }
    },
    methods:{
      clickStep(index){
        this.$emit('clickStep',index);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .steps {
    display: flex;
  }
  .steps  .is_finish{
    color:#fff;
    border-color:#fff;
  }
  .steps  .is_finish.step-line{
    background-color: #fff;
  }

  .steps  .is_active{
    .step-icon{
      border-color:#fff;
      background: #fff;
      color:$dark;
    }
  }
  .steps  .is_active.step-line{
    background-color: #fff;
  }
  .step:last-of-type{
    flex-basis: auto;
  }
  .step {
    flex-basis: 50%;
    color:#999DAA;
    border-color:#999DAA;
    .steps-main {
      padding: 5px;
      white-space: nowrap;
    }
    .step-icon {
      position: relative;
      display: inline-block;
      width: 60px;
      height: 60px;
      border: 4px solid ;
      border-radius: 50%;
      text-align: center;
      background: $dark;
      font-size: 30px;
      line-height: 45px;
      z-index: 1;
      cursor:pointer;


    }
    .step-head {
      position: relative;

    }
    .step-line {
      position: absolute;
      background-color: #999DAA;
      height: 4px;
      top: 28px;
      left: 0%;
      right: 0%;
    }

  }


</style>



// WEBPACK FOOTER //
// src/view/subSystem/steps.vue